/**
 * Checks if a defect type code is considered a default code.
 * A default code is either:
 * 1. null, undefined, or empty string
 * 2. Ends with ".999999" (e.g., "HULL.999999")
 * 
 * @param typeCode - The defect type code to check
 * @returns true if the code is default/blank, false otherwise
 */
export const isDefaultDefectCode = (typeCode: string | null | undefined): boolean => {
    // Check for null, undefined, or empty string
    if (!typeCode) {
        return true;
    }
    
    // Check for codes ending in 999999
    if (typeCode.includes('.')) {
        const [, numberPart] = typeCode.split('.');
        return numberPart === '999999';
    }
    
    return false;
};
